<template>
  <span class="inline-block" data-allow-mismatch>
    <span
      class="inline-block w-full h-[1em] rounded-full bg-gray-200 align-sub"
    >
      &nbsp;
    </span>
  </span>
</template>
